import "./Buttons.scss";
import React, { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Subject } from "rxjs";
import { Button } from "antd";
import { CheckCircleTwoTone } from "@ant-design/icons";

export const signaturePDF: Subject<string> = new Subject();

export const SignLeaveBtn = ({ open }: { open: boolean }) => {
  const sigCanvasRef = useRef<SignatureCanvas | null>(null);
  const wrapRef = useRef<HTMLDivElement | null>(null);
  const [signature, setSignature] = useState(false);

  useEffect(() => {
    if (!open) return;

    const raf = requestAnimationFrame(() => {
      const wrap = wrapRef.current;
      const sig = sigCanvasRef.current;
      if (!wrap || !sig) return;

      const rect = wrap.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) return;

      const canvas = sig.getCanvas();
      const dpr = window.devicePixelRatio || 1;

      canvas.width = Math.floor(rect.width * dpr);
      canvas.height = Math.floor(rect.height * dpr);

      const ctx = canvas.getContext("2d");
      if (ctx) ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      sig.clear();
    });

    return () => cancelAnimationFrame(raf);
  }, [open]);

  const saveSignature = () => {
    const sig = sigCanvasRef.current;
    if (!sig || sig.isEmpty()) return;
    signaturePDF.next(sig.getTrimmedCanvas().toDataURL("image/png"));
    setSignature(true);
  };

  const clearSignature = () => {
    sigCanvasRef.current?.clear();
    signaturePDF.next("");
    setSignature(false);
  };

  return (
    <div>
      <div ref={wrapRef} className="sign-canvas-wrapper">
        <SignatureCanvas
          penColor="black"
          ref={sigCanvasRef}
          canvasProps={{ className: "sigCanvas" }}
        />
      </div>

      <Button
        disabled={signature}
        onClick={saveSignature}
        className="signature-btn"
      >
        Save signature
      </Button>
      <Button onClick={clearSignature} className="signature-btn">
        Clear
      </Button>

      {signature && <CheckCircleTwoTone twoToneColor="#52c41a" />}
    </div>
  );
};
